import { render } from "./GetProducts.vue?vue&type=template&id=674d731f"
import script from "./GetProducts.vue?vue&type=script&lang=js"
export * from "./GetProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/inputs/GetProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "674d731f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('674d731f', __exports__)) {
    api.reload('674d731f', __exports__)
  }
  
  module.hot.accept("./GetProducts.vue?vue&type=template&id=674d731f", () => {
    api.rerender('674d731f', render)
  })

}


export default __exports__